import Link from 'next/link'
import { BookmarkCheckIcon } from 'lucide-react'

/** Track confirmation content for tooltip, styled like TrackTagUntrackConfirm. */
export const TrackTagTrackConfirm = () => (
  <div className="flex max-w-50 flex-col items-center gap-2 py-1 text-center text-balance">
    <div className="flex size-8 items-center justify-center rounded-lg bg-accent-foreground p-1.5">
      <BookmarkCheckIcon className="size-4 text-accent" />
    </div>
    <p className="text-xs font-semibold text-foreground">
      Track this bill to stay updated on its progress. View all of your tracked bills on your{' '}
      <Link href="/dashboard" className="text-evergreen-600 hover:underline">
        dashboard
      </Link>
      .
    </p>
  </div>
)
